/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const mainReason = useStore((state) => state.mainReason);
  const setMainReason = useStore((state) => state.setMainReason);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.mainReason.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={mainReason}
          onChange={(value) => {
            setMainReason(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'main-reason',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'confidence'}>
            <span>💪</span> {t('onboarding.mainReason.options.confidence')}
          </Option>
          <Option value={'attractive'}>
            <span>😍</span> {t('onboarding.mainReason.options.attractive')}
          </Option>
          <Option value={'health'}>
            <span>⚡</span> {t('onboarding.mainReason.options.health')}
          </Option>
          <Option value={'mentalHealth'}>
            <span>🧘</span> {t('onboarding.mainReason.options.mentalHealth')}
          </Option>
          <Option value={'clothes'}>
            <span>👖</span> {t('onboarding.mainReason.options.clothes')}
          </Option>
          <Option value={'other'}>
            <span>✳️</span> {t('onboarding.mainReason.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
